import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IndexorModule } from "./indexor/indexor.module";
import { ReplicatorModule } from "./replicator/replicator.module";
import { StoreErrorModule } from "./store-error/store-error.module";

@NgModule({
	declarations: [],
	imports: [CommonModule, ReplicatorModule, IndexorModule, StoreErrorModule]
})
export class StoreModule {}
